import { useState, useEffect } from 'react';
import { fetchIncotermTimeline } from '../../../Components/QuantityTable/utils/quantityDeliveryUtils';
import { PricingPeriodData } from '../../../constants/masterData';
import HpsParcelSection from './HpsParcel';

const mapParcel = (data, incotermTimelineItems) => ({
  ...data,
  pricingPeriodLabel:
    PricingPeriodData[0]?.options?.find(o => o.value === data.pricingPeriod)
      ?.label || '-',
  indexPrice: data.indexPricename,
  otherIndexPrice: data.otherIndexPricename,
  incotermTimelineItems,
});

const HpsParcelSectionWithData = ({
  parcels = [],
  procurement,
  token,
  isReadOnly = false,
  alphaUploadVersion = 0,
}) => {
  const [enrichedParcels, setEnrichedParcels] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!parcels.length) {
      setEnrichedParcels([]);
      setIsLoading(false);
      return;
    }

    let cancelled = false;

    const loadAll = async () => {
      setIsLoading(true);
      try {
        const results = await Promise.all(
          parcels.map(async data => {
            const { timelineItems } = await fetchIncotermTimeline(
              data.id,
              token
            );
            return mapParcel(data, timelineItems);
          })
        );
        if (!cancelled) {
          setEnrichedParcels(results);
        }
      } catch {
        if (!cancelled) {
          setEnrichedParcels(parcels.map(data => mapParcel(data, [])));
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    };

    loadAll();
    return () => {
      cancelled = true;
    };
  }, [parcels, token, alphaUploadVersion]);

  return (
    <HpsParcelSection
      parcels={enrichedParcels}
      isLoadingParcels={isLoading}
      procurement={procurement}
      isReadOnly={isReadOnly}
    />
  );
};

export default HpsParcelSectionWithData;
